import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import Pagination from '@material-ui/lab/Pagination';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import classNames from 'classnames';

const styles = theme => ({
  alignRight: {
    display: 'flex',
    padding: 12,
    paddingLeft: 20,
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  labelInput: {
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '0.03333em',
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0
    }
  },
  textCount: {
    display: 'inline-block',
    padding: '0 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 5px'
    }
  },
  paddingLeft8: {
    paddingLeft: 8,
    fontSize: '0.75rem',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:before': {
      border: 'none'
    },
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
      '&:not(.Mui-disabled)': {
        '&:before': {
          border: 'none'
        }
      }
    },
    '&:after': {
      display: 'none'
    }
  }
});

const enhance = compose();

const ExPagination = enhance(
  ({
    classes,
    totalCount,
    offset,
    handleChangePage,
    searchSortKey,
    // sortType,
    sortOrder,
    limit,
    setLimit,
    selectedPage,
    handleChangeRowsPerPage
  }) => {
    console.log('PAGE LIMIT: ', limit);
    const handleChangeLimit = event => {
      setLimit(event.target.value);
      handleChangePage(
        null,
        1,
        event.target.value,
        searchSortKey,
        // sortType,
        sortOrder
      );
      handleChangeRowsPerPage(event, event.target.value);
    };
    return (
      <div>
        <div className={classes.alignRight}>
          <InputLabel id="rowsPerPageLabel" className={classes.labelInput}>
            Rows per page:
          </InputLabel>
          <FormControl className={classes.formControl}>
            <Select
              labelId="rowsPerPageLabel"
              id="rowsPerPage"
              value={limit}
              onChange={handleChangeLimit}
              className={classes.paddingLeft8}
              fontSize={14}
            >
              <MenuItem value={5} data-limit-value={5}>
                5
              </MenuItem>
              <MenuItem value={25} data-limit-value={25}>
                25
              </MenuItem>
              <MenuItem value={100} data-limit-value={100}>
                100
              </MenuItem>
            </Select>
          </FormControl>

          <InputLabel
            id="rowsPerPageLabel"
            className={classNames(classes.labelInput, classes.textCount)}
          >
            {totalCount > 0 ? offset + 1 : 0}
            <span>-</span>
            {offset + limit < totalCount ? offset + limit : totalCount}
            <span> of </span>
            {totalCount}
          </InputLabel>

          <Pagination
            count={
              totalCount % limit > 0
                ? Math.floor(totalCount / limit) + 1
                : Math.floor(totalCount / limit)
            }
            page={selectedPage}
            onChange={(event, page) => {
              handleChangePage(
                null,
                page,
                limit,
                searchSortKey,
                // sortType,
                sortOrder
              );
            }}
            color="primary"
            size="small"
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(ExPagination));
